/**
 * Get taide.art logo src.
 */
export const getSiteLogoSrc = function (inBlack) {
    const site = 'taide.art';
    if (site.match('taide.art')) {
        return inBlack ?
            require('assets/images/taide-art-black.svg')
            : require('assets/images/taide-art-white.svg');
    }
    else {
        return inBlack ?
            require('assets/images/logo-black.png')
            : require('assets/images/logo-white.png');
    }
};

/**
 * Get taide.art circles src in contrasting theme color.
 */
export const getTaideArtDotSrc = function (inBlack) {
    if (inBlack) {
        return require('assets/images/TaideArtPiste.svg');
    }
    else {
        return require('assets/images/TaideArtPisteValkoinen.svg');
    }
};

export default {

    methods: {

        getSiteLogoSrc,
        getTaideArtDotSrc,

        /**
         * Get taide.art circles src in contrasting theme color.
         */
        getThemedTaideArtDotSrc: function () {
            return getTaideArtDotSrc(this.$store.getters['ux/getTheme'] !== 'dark');
        }
    }
};
